import { getWebComponentHost } from "./getWebComponentHost"

const DEFAULT_RECAPTCHA_TEXT = "This site is protected by reCAPTCHA."
const HIDDEN_VALUES = new Set(["", "false", "none", "off", "hidden"])

/**
 * r2wc skips empty HTML attributes (`if (value)`), so `recaptcha-text=""` never
 * reaches React. Read the host attribute when present, and treat empty / false /
 * none / off / hidden as hidden.
 */
export function resolveRecaptchaText(
  recaptchaText: string | undefined,
  container?: HTMLElement
): string {
  const host = getWebComponentHost(container)
  const raw =
    host?.hasAttribute("recaptcha-text") === true
      ? (host.getAttribute("recaptcha-text") ?? "")
      : recaptchaText

  if (raw === undefined) return DEFAULT_RECAPTCHA_TEXT
  if (HIDDEN_VALUES.has(String(raw).trim().toLowerCase())) return ""
  return String(raw)
}
